import PropTypes from 'prop-types'
import React from 'react'
import Base from '../../containers/BaseContainer'
import { I18n } from 'react-redux-i18n'
import Select from 'react-select'
import styles from './AppEditorContent.module.scss'
import Constants from '../../services/constants/Constants'
import Toggle from '../Toggle/Toggle'
import { isAnEditableApp } from '../../ApplicationUtils'

class AppEditorContent extends Base {

  constructor(props) {
    super(props)
    this._bind('_getAllLocales', '_getFilteredLocales', '_getSelectedLocaleCodes', '_getSelectedDefaultLocaleCode',
      '_onInputChange', '_onLangsChange', '_onDefaultLangChange', '_onAndroidChange', '_onIOSChange',
      '_onStoreChange', '_getName', '_getOwner', '_getAndroid', '_getIOS', '_getStore', '_getApps', '_onFromAppChange',
      '_onOwnerChange', '_onCopyChange', '_onFromOwnerChange', '_getCopy', '_getFromOwner', '_getFromApp',
      '_renderMapWizeConf', '_getAppVersion', '_getCopyUsers', '_getOwnerUsers')

    this.state = { app: this._initApp() }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let app = nextProps.app
    if (!app.id && nextProps.locales && nextProps.locales.length && !app.locales) {
      app = this._initApp(nextProps)
      nextProps.locales.map((locale, index) => {
        app.locales.push({ locale: { code: locale.code }, isDefault: (index === 0) })
        return null
      })
      this.props.onChange(app)
    } else {
      this.setState({ app })
    }
  }

  _initApp(props) {
    return {
      name: '',
      version: '1.0',
      usersFO: [{
        userFO: {
          email: props && props.currentUser && props.currentUser.email
            ? props.currentUser.email : '',
        }, isOwner: true,
      }],
      stores: [{ store: Constants.AppsConstants.STORE.ANDROID, active: false },
      { store: Constants.AppsConstants.STORE.IOS, active: false }],
      touched: {
        name: false, version: false, langs: false, stores: false, owner: false,
        copy: false, mapWizeApiKey: false, mapWizeAccessKey: false, subscriptionDef: false, 
        showSubscriptionAfterLogin: false,
      },
      locales: [],
      errors: {},
    }
  }

  _onInputChange(event) {
    let app = this.state.app
    if (event.currentTarget && event.currentTarget.name) {
      switch (event.currentTarget.name) {
        case 'name':
          app.name = event.currentTarget.value
          app.touched.name = true
          this.props.onChange(app)
          break
        case 'version':
          app.version = event.currentTarget.value
          app.touched.version = true
          this.props.onChange(app)
          break
        case 'mapWizeApiKey':
          app.mapWizeApiKey = event.currentTarget.value
          app.touched.mapWizeApiKey = true
          this.props.onChange(app)
          break
        case 'mapWizeAccessKey':
          app.mapWizeAccessKey = event.currentTarget.value
          app.touched.mapWizeAccessKey = true
          this.props.onChange(app)
          break
        case 'subscriptionDefFR':
          if (!app.hasOwnProperty('subscriptionDef')) {
            app.subscriptionDef = {
              type: "TEXT",
              translations: [
                { locale: { "code": "fr" }, translation: "" },
                { locale: { "code": "en" }, translation: "" },
              ]
            }
          }
          let idx = app.subscriptionDef.translations.findIndex(t => t.locale.code === 'fr')
          app.subscriptionDef.translations[idx].translation = event.currentTarget.value
          app.touched.subscriptionDef = true

          this.props.onChange(app)
          break
        case 'subscriptionDefEN':
          if (!app.hasOwnProperty('subscriptionDef')) {
            app.subscriptionDef = {
              type: "TEXT",
              translations: [
                { locale: { "code": "fr" }, translation: "" },
                { locale: { "code": "en" }, translation: "" },
              ]
            }
          }
          let idxEN = app.subscriptionDef.translations.findIndex(t => t.locale.code === 'en')
          app.subscriptionDef.translations[idxEN].translation = event.currentTarget.value
          app.touched.subscriptionDef = true
          this.props.onChange(app)

          break
        default:
          break
      }
    }
  }

  _onLangsChange(items) {
    let app = this.state.app

    // get the application default locale
    let defaultLocale = this._getSelectedDefaultLocaleCode()

    // Rebuild the application locales and name
    app.locales = []
    let checkDefaultExist = false
    items.forEach((item) => {
      if (item.value) {
        if (item.value === defaultLocale) {
          checkDefaultExist = true
        }
        app.locales.push({ locale: { code: item.value }, isDefault: (item.value === defaultLocale) })
      }
    })

    if (!checkDefaultExist && app.locales.length) {
      app.locales[0].isDefault = true
    }

    app.touched.langs = true
    this.props.onChange(app)
  }

  _onDefaultLangChange(item) {
    let app = this.state.app
    app.locales.map((locale, index) => {
      app.locales[index].isDefault = (item && locale.locale.code === item.value)
      return null
    })

    this.props.onChange(app)
  }

  _onOwnerChange(item) {
    let app = this.state.app
    app.usersFO[0].userFO.email = item ? item.value : null
    app.usersFO.forEach((appUser) => {
      appUser.isOwner = (item && appUser.userFO.email === item.value)
    })

    this.props.onChange(app)
  }

  _onFromOwnerChange(item) {
    let app = this.state.app
    app.fromApp = null
    app.fromOwner = item ? item.value : null

    this.props.onFromOwnerChange(app)
  }

  _onCopyChange(event) {
    let app = this.state.app
    app.copy = event.currentTarget.checked
    this.props.onChange(app)
  }

  _onFromAppChange(item) {
    let app = this.state.app
    app.fromApp = item ? item.value : null
    this.props.onChange(app)
  }
  _showSubscriptionAfterLoginChanged = (event) => {
    let app = this.state.app
    app.showSubscriptionAfterLogin = event.currentTarget.checked
    app.touched.showSubscriptionAfterLogin = true
    this.props.onChange(app)
  }
  _onAndroidChange(event) {
    this._onStoreChange(Constants.AppsConstants.STORE.ANDROID, event.currentTarget.checked)
  }

  _onIOSChange(event) {
    this._onStoreChange(Constants.AppsConstants.STORE.IOS, event.currentTarget.checked)
  }

  _onStoreChange(storeValue, active) {
    let app = this.state.app
    let found = false
    app.stores.forEach((store, index) => {
      if (store.store === storeValue) {
        store.active = active
        found = true
      }
    })
    if (!found) {
      app.stores.push({ store: storeValue, publishStatus: 'NOT_PUBLISH', active: true })
    }
    app.touched.stores = true
    this.props.onChange(app)
  }

  _getFromApp() {
    return this.state.app.fromApp
  }

  _getApps(props) {
    let appOptions = []
    if (props.userApps) {
      let defaultLocale = this._getSelectedDefaultLocaleCode()
      props.userApps.forEach((app) => {
        let appName
        app.name.translations.forEach((translation, index) => {
          if (defaultLocale && translation.locale.code === defaultLocale) {
            appName = translation.translation
          }
        })
        if (!appName) {
          appName = app.name.translations[0]
        }
        appOptions.push({ value: app.id, label: appName + ' - ' + app.version })
      })
    }

    return appOptions
  }

  _getName() {
    let name = ''
    if (this.state.app && this.state.app.name) {
      name = this.state.app.name
    }
    return name
  }

  _getAppVersion() {
    let version = this.state.app.version
    return version
  }

  _getCopy() {
    return this.state.app.copy
  }

  _getAndroid() {
    return this._getStore(Constants.AppsConstants.STORE.ANDROID)
  }

  _getIOS() {
    return this._getStore(Constants.AppsConstants.STORE.IOS)
  }

  _getStore(storeValue) {
    let app = this.state.app
    let active = false
    if (app.stores) {
      app.stores.forEach((store) => {
        if (store.store === storeValue) active = store.active
      })
    }

    return active
  }

  _getOwner() {
    let owner = ''
    if (this.state.app && this.state.app.usersFO) {
      owner = this.state.app.usersFO[0].userFO.email
    }
    return owner
  }

  _getFromOwner() {
    return this.state.app.fromOwner
  }

  _getAllLocales(props) {
    let localeOptions = []
    if (props.locales) {
      props.locales.forEach((locale) => {
        localeOptions.push({ value: locale.code, label: locale.code })
      })
    }

    return localeOptions
  }

  _getCopyUsers(props) {
    let userOptions = []
    if (props.copyUsers && props.copyUsers.length) {
      props.copyUsers.forEach((user) => {
        userOptions.push({ value: user.email, label: user.email })
      })
    }
    return userOptions
  }

  _getOwnerUsers(props) {
    let userOptions = []
    if (props.ownerUsers && props.ownerUsers.length) {
      props.ownerUsers.forEach((user) => {
        userOptions.push({ value: user.email, label: user.email })
      })
    }
    return userOptions
  }

  _getFilteredLocales() {
    let localeOptions = []
    if (this.state.app.locales) {
      this.state.app.locales.forEach((locale) => {
        localeOptions.push({ value: locale.locale.code, label: locale.locale.code })
      })
    }

    return localeOptions
  }

  _getSelectedLocaleCodes() {
    let localeValues = []
    let appLocales = this.state.app.locales
    if (appLocales) {
      appLocales.forEach((locale) => {
        localeValues.push(locale.locale.code)
      })
    }

    return localeValues
  }

  _getSelectedDefaultLocaleCode() {
    let defaultLocale = ''
    let app = this.state.app
    if (app.locales) {
      app.locales.forEach((locale, index) => {
        if (locale.isDefault) {
          defaultLocale = locale.locale.code
        }
      })

      if (!defaultLocale && app.locales.length) {
        defaultLocale = app.locales[0].locale.code
      }
    }

    return defaultLocale
  }

  _renderCopyApp() {
    return (
      <div>
        <div className={styles.publication}>
          <label htmlFor='copy' className={styles.name}>
            <span>{I18n.t('Application.copy')}</span>
            <div className={styles.row}>
              <Toggle type={'check'} position={0} toggleInitState={this._getCopy()}
                toggleChanged={this._onCopyChange} />
            </div>
          </label>
        </div>

        {this.state.app.copy ? <div>
          <label htmlFor='fromOwner' className={styles.name}>
            <span>{I18n.t('Application.copyOwner')}</span>
            <div className={styles.row}>
              <Select name='fromOwner' options={this._getCopyUsers(this.props)}
                value={this._getFromOwner()}
                placeholder={I18n.t('Application.select_owner')}
                clearable={false}
                noResultsText={I18n.t('select.noResult')}
                onChange={this._onFromOwnerChange} />
            </div>
          </label>

          <label htmlFor='fromApp' className={styles.name}>
            <span>{I18n.t('Application.copyFromApp')}</span>
            <div className={styles.row}>
              <Select name='fromApp' options={this._getApps(this.props)}
                value={this._getFromApp()}
                directionUp
                placeholder={I18n.t('Application.select_app')}
                clearable={false}
                noResultsText={I18n.t('select.noResult')}
                onChange={this._onFromAppChange} />
            </div>
          </label>
        </div> : null}

      </div>
    )
  }

  _renderMapWizeConf() {
    let errors = this.state.app.errors ? this.state.app.errors : {}
    let touched = this.state.app.touched ? this.state.app.touched
      : { name: false, version: false, langs: false, stores: false, owner: false, copy: false }
    let errorClass = styles.name + ' error ' + styles.error

    return (
      <div style={{
        display: 'flex',
        width: "100%"
      }}>
        <label htmlFor='mapWizeApiKey'
          className={touched.mapWizeApiKey && errors.mapWizeApiKey ? errorClass : styles.name}>
          <span>MapWize Api key</span>
          <div className={styles.row}>
            <input type='text' name='mapWizeApiKey' value={this.state.app.mapWizeApiKey} className={styles.formInput}
              tabIndex='-1' disabled={this.props.disabled}
              onChange={this._onInputChange} />
            {touched.mapWizeApiKey && errors.mapWizeApiKey ? <span> {errors.mapWizeApiKey} </span> : null}
          </div>
        </label>
        <label htmlFor='mapWizeAccessKey'
          className={touched.mapWizeAccessKey && errors.mapWizeAccessKey ? errorClass : styles.name}>
          <span>{I18n.t('Application.mapWizeAccessKey')}</span>
          <div className={styles.row}>
            <input type='text'
              tabIndex='-1' disabled={this.props.disabled}
              name='mapWizeAccessKey'
              value={this.state.app.mapWizeAccessKey}
              className={styles.formInput}
              onChange={this._onInputChange} />
            {touched.mapWizeAccessKey && errors.mapWizeAccessKey ? <span> {errors.mapWizeAccessKey} </span> : null}
          </div>
        </label>
      </div>
    )
  }
  geti18n = (path, locale) => {
    let app = this.state.app
    if (app.hasOwnProperty(path)) {
      return app[path].translations.find(t => t.locale.code === locale).translation
    } else return ""
  }
  render() {
    let androidActive = this._getAndroid()
    let showSubscriptionAfterLogin = this.state.app.showSubscriptionAfterLogin
    let IOSActive = this._getIOS()
    let errors = this.state.app.errors ? this.state.app.errors : {}
    let touched = this.state.app.touched ? this.state.app.touched
      : { name: false, version: false, langs: false, stores: false, owner: false, copy: false }
    let errorClass = styles.name + ' error ' + styles.error
    let canEdit = (!this.state.app.status || isAnEditableApp(this.state.app))

    return (
      <div className={styles.editorContent}>
        <form className={styles.appForm}>
          <div className={styles.interests}>
            Général
          </div>
          <label htmlFor='name' className={touched.name && errors.name ? errorClass : styles.name}>
            <span>{I18n.t('Application.name')}</span>
            <div className={styles.row}>
              <input type='text' name='name' value={this._getName()} className={styles.formInput}
                tabIndex='-1' disabled={!canEdit || this.props.disabled}
                onChange={this._onInputChange} />
              {touched.name && errors.name ? <span> {errors.name} </span> : null}
            </div>
          </label>
          <label htmlFor='version' className={touched.version && errors.version ? errorClass : styles.name}>
            <span>{I18n.t('Application.version')}</span>
            <div className={styles.row}>
              <input type='text' name='version' value={this._getAppVersion()} className={styles.formInput}
                tabIndex='-1' disabled={!canEdit || this.props.disabled}
                onChange={this._onInputChange} />
              {touched.version && errors.version ? <span> {errors.version} </span> : null}
            </div>
          </label>
          <label htmlFor='langs' className={touched.langs && errors.langs ? errorClass : styles.name}>
            <span>{I18n.t('Application.langs')}</span>
            <div className={styles.row}>
              <Select name='langs' multi options={this._getAllLocales(this.props)}
                tabIndex='-1' disabled={!canEdit || this.props.disabled}
                value={this._getSelectedLocaleCodes()}
                placeholder={I18n.t('Application.select_langs')}
                noResultsText={I18n.t('select.noResult')}
                onChange={this._onLangsChange} />
              {touched.langs && errors.langs ? <span> {errors.langs} </span> : null}
            </div>
          </label>
          <label htmlFor='lang' className={styles.name}>
            <span>{I18n.t('Application.default_lang')}</span>
            <Select name='lang' options={this._getFilteredLocales()}
              tabIndex='-1' disabled={!canEdit || this.props.disabled}
              value={this._getSelectedDefaultLocaleCode()}
              placeholder={I18n.t('Application.select_default_lang')}
              clearable={false}
              noResultsText={I18n.t('select.noResult')}
              onChange={this._onDefaultLangChange} />
          </label>
          <label htmlFor='owner' className={touched.owner && errors.owner ? errorClass : styles.name}>
            <span>{I18n.t('Application.owner')}</span>
            {!this.props.app.id ? <div className={styles.row}>
              <Select name='owner' options={this._getOwnerUsers(this.props)}
                tabIndex='-1' disabled={this.props.disabled || !this.props.canChangeOwner}
                value={this._getOwner()}
                placeholder={I18n.t('Application.select_owner')}
                clearable={false}
                noResultsText={I18n.t('select.noResult')}
                onChange={this._onOwnerChange} />
              {touched.owner && errors.owner ? <span> {errors.owner} </span> : null}
            </div> : null}

            {this.props.app.id
              ? <div className={styles.row}>
                <input type='text' value={this._getOwner()} disabled readOnly className={styles.formInput} />
              </div>
              : null}

          </label>
          <div className={styles.publication}>
            <label htmlFor='android' className={touched.stores && errors.stores ? errorClass : styles.name}>
              <span>{I18n.t('Application.stores.android')}</span>
              <div className={styles.row}>
                <Toggle type={'check'} position={0} toggleInitState={androidActive}
                  tabIndex='-1' disabled={this.props.disabled}
                  toggleChanged={canEdit ? this._onAndroidChange : () => { }} />
              </div>
              {touched.stores && errors.stores ? <span className={styles.error}>{errors.stores}</span> : null}
            </label>
            <label htmlFor='ios' className={touched.stores && errors.stores ? errorClass : styles.name}>
              <span>{I18n.t('Application.stores.ios')}</span>
              <div className={styles.row}>
                <Toggle type={'check'} position={0} toggleInitState={IOSActive}
                  tabIndex='-1' disabled={this.props.disabled}
                  toggleChanged={canEdit ? this._onIOSChange : () => { }} />
              </div>
            </label>
          </div>

          {this.props.canUseMapWize ? this._renderMapWizeConf() : null}

          {this.props.canCopy && !this.state.app.id ? this._renderCopyApp() : null}

          <div className={styles.interests}>
            Centre d'intérêt
          </div>
          <label htmlFor='showSubscriptionAfterLogin' className={styles.name} style={{ width: "100%" }}>
            <span>{I18n.t('Application.showSubscriptionAfterLogin')}</span>
            <div className={styles.row}>
              <Toggle
                type={'check'}
                position={0}
                toggleInitState={showSubscriptionAfterLogin}
                tabIndex='-1'
                toggleChanged={canEdit ? this._showSubscriptionAfterLoginChanged : () => { }} />
            </div>
          </label>
          <div style={{
            display: 'flex',
            width: "100%"
          }}>
            <label htmlFor='subscriptionDefFR'
              className={touched.mapWizeApiKey && errors.mapWizeApiKey ? errorClass : styles.name}
            >
              <span>Définition de la notion de "centre d'intérêt" (fr) : </span>
              <div className={styles.row}>
                <input
                  type='text'
                  name='subscriptionDefFR'
                  value={this.geti18n('subscriptionDef', 'fr')}
                  className={styles.formInput}
                  tabIndex='-1'
                  // disabled={!showSubscriptionAfterLogin}
                  onChange={this._onInputChange} />
              </div>
            </label>
            <label htmlFor='subscriptionDefEN'
              className={touched.mapWizeAccessKey && errors.mapWizeAccessKey ? errorClass : styles.name}>
              <span>Définition de la notion de "centre d'intérêt" (en) : </span>
              <div className={styles.row}>
                <input
                  type='text'
                  tabIndex='-1'
                  // disabled={!showSubscriptionAfterLogin}
                  name='subscriptionDefEN'
                  value={this.geti18n('subscriptionDef', 'en')}
                  className={styles.formInput}
                  onChange={this._onInputChange} />
              </div>
            </label>
          </div>
        </form>
      </div>
    )
  }

}

AppEditorContent.propTypes = {
  disabled: PropTypes.bool,
  app: PropTypes.object.isRequired,
  canCopy: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  canUseMapWize: PropTypes.bool.isRequired,
  locales: PropTypes.array.isRequired,
  copyUsers: PropTypes.array.isRequired,
  currentUser: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onFromOwnerChange: PropTypes.func.isRequired,
}

export default AppEditorContent
